import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, map } from 'rxjs/operators';
import { SubscriptionState } from '~app/farp-odq/store/subscription';
import { ProceedSubscriptionPayment } from '~app/farp-odq/store/subscription/subscription.actions';
import { SelectedPremiumInfo, SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-registration-credit',
    templateUrl: './registration-credit.component.html',
    styleUrls: ['./registration-credit.component.scss'],
    standalone: false
})
export class RegistrationCreditComponent implements OnInit {
  @Input() model: SubscriptionFormViewModel;
  @Input() selectedPremium: SelectedPremiumInfo;
  
  paymentError$ = this.store.select<string>(SubscriptionState.paymentError);
  isTransactionProcessing: boolean;
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.initPayment();
  }

  private initPayment() {  
    // handling errors 
    this.paymentError$.pipe(
      filter(errorMessage => !!errorMessage),
      map(errorMesage => {
        console.log('paymentError', errorMesage);
        this.isTransactionProcessing = false;
      })
    ).subscribe()
  }
  
  doCredit() {
    this.isTransactionProcessing = true;
    this.selectedPremium.setCreditInfo();
    this.store.dispatch(new ProceedSubscriptionPayment(this.selectedPremium));
  }
 
}